var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lottie__container" }, [
    _c("div", { ref: "lavContainer", staticClass: "lottie" }),
    _c("h1", { staticClass: "lottie__label" }, [
      _vm._v(_vm._s(_vm.$t("lbl_please_wait")))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }